export default "__VITE_PUBLIC_ASSET__63cbd466__"